import { createReducer } from '@reduxjs/toolkit';

import { IAction } from '../../types/redux';
import { sameToken } from '../../utils/SyncGroup/session.types';
import { PROJECT_CLEAN } from '../editor';

import {
  ISyncStateCommitAction,
  ISyncStateResetAction,
  SyncStatus,
  ISyncState,
  SYNC_STATE_COMMIT,
  SYNC_STATE_RESET,
  UPDATE_CONFLICT_STATE,
  IUpdateConflictStateAction,
} from './sync.types';

const INITIAL_STATE: ISyncState = {
  sync: {
    session: null,
    hydrating: false,
    isEnabled: false,
    status: SyncStatus.INACTIVE,
    reason: null,
  },
  conflictState: {
    dispenser: {},
    registry: {},
    conflicts: {},
    remoteEvents: [],
    localEvents: [],
    applyOnClient: [],
    applyOnServer: [],
  },
};

export const syncReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(
      UPDATE_CONFLICT_STATE,
      (state: ISyncState, action: IAction<IUpdateConflictStateAction>) => {
        if (!action.payload) {
          return;
        }

        state.conflictState = {
          ...state.conflictState,
          ...action.payload,
        };
      },
    )
    .addCase(PROJECT_CLEAN, (state: ISyncState) => {
      // Проект закрыт — токен больше не валиден, статус нейтрализуется (§2.8).
      state.sync.session = null;
      state.sync.hydrating = false;
      state.sync.isEnabled = false;
      state.sync.status = SyncStatus.INACTIVE;
      state.sync.reason = null;
    })
    // Открытие сессии проекта: атомарный ресет + адопт токена (несёт generation) (§2.8).
    .addCase(SYNC_STATE_RESET, (state: ISyncState, action: IAction<ISyncStateResetAction>) => {
      if (!action.payload?.session) {
        return;
      }
      state.sync.session = action.payload.session;
      state.sync.hydrating = true;
      state.sync.isEnabled = null;
      state.sync.status = SyncStatus.INACTIVE;
      state.sync.reason = null;
    })
    // Единственный мутатор статуса: применяем ТОЛЬКО для текущей сессии (projectId И
    // generation) и снимаем hydrating. Поздний коммит устаревшей сессии отбрасывается (§2.8).
    .addCase(SYNC_STATE_COMMIT, (state: ISyncState, action: IAction<ISyncStateCommitAction>) => {
      const { payload } = action;
      if (!payload?.session || !sameToken(payload.session, state.sync.session)) {
        return;
      }

      state.sync.hydrating = false;
      state.sync.status = payload.status;
      state.sync.reason = payload.reason ?? null;
      if (typeof payload.isEnabled !== 'undefined') {
        state.sync.isEnabled = payload.isEnabled;
      }
    });
});
